import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ChevronDown from '../common/Icons/ChevronDown';
import AssignmentContext from '../common/AssignmentContext/AssignmentContext';
import { rtl } from '../../utils/language';

const Teams = ({ teamsData }) => {
  const [isExpanded, setExpanded] = useState(false);
  const { t } = useTranslation();

  const {
    assignmentData: { assignmentType },
    filters: { selectedTeamFilter, setselectedTeamFilter },
  } = useContext(AssignmentContext);

  const assignmentTypeForPendo = assignmentType
    .split('_')
    .join('-')
    .toLowerCase();

  const onTeamSelection = teamId => () =>
    setselectedTeamFilter(prev => {
      if (prev === teamId) return '';
      return teamId;
    });

  return (
    <Wrapper>
      <ChevronWrapper
        onClick={() => {
          setExpanded(!isExpanded);
        }}
        className={`${
          isExpanded ? 'expanded' : ''
        } data-analytics-${assignmentTypeForPendo}-class-dashboard-teams-${
          isExpanded ? 'collapse' : 'expand'
        }`}
      >
        <ChevronDown size={20} color="black" />
      </ChevronWrapper>
      <TeamBlock
        onClick={onTeamSelection('')}
        className={`${isExpanded ? 'expanded' : ''} ${
          selectedTeamFilter === '' ? 'selected' : ''
        }`}
      >
        {t('All')}
      </TeamBlock>
      {teamsData.map(team => (
        <TeamBlock
          data-testid="team-block"
          key={team.id}
          className={`${isExpanded ? 'expanded' : ''} ${
            selectedTeamFilter === team.id ? 'selected' : ''
          }`}
          data-tip={team.name}
          onClick={onTeamSelection(team.id)}
        >
          {isExpanded ? (
            <>
              <span>{team.name}</span>
              <i
                data-testid={`team-icon--${team.icon}`}
                className={`assignments-icon ${team.icon} colored`}
              />
            </>
          ) : (
            <i
              data-testid={`team-icon--${team.icon}`}
              className={`assignments-icon ${team.icon} colored`}
            />
          )}
        </TeamBlock>
      ))}
    </Wrapper>
  );
};

Teams.propTypes = {
  teamsData: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
};

export default Teams;

const ChevronWrapper = styled.div`
  padding: 10px;
  margin: 0px 10px;
  height: 50px;
  width: 50px;
  cursor: pointer;

  svg {
    transform: rotate(-90deg);
    ${rtl`
      transform: rotate(90deg);
  `};
  }

  &.expanded {
    svg {
      transform: rotate(90deg);
      ${rtl`
      transform: rotate(-90deg);
  `};
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: bold;
`;

const TeamBlock = styled.div`
  font-size: 16px;
  background: #ededed;
  padding: 10px;
  margin: 10px 0;
  height: 50px;
  width: 50px;
  text-align: center;
  border-radius: 6px;
  border: solid 2px #ededed;
  cursor: pointer;
  transition: width 0.5s;
  overflow: hidden;
  white-space: nowrap;

  display: flex;
  justify-content: center;
  align-items: center;

  &:nth-of-type(2) {
    margin-top: 0;
  }

  .assignments-icon {
    vertical-align: middle;
  }

  &.selected,
  &:hover {
    border: solid 2px #21bcb6;
  }

  &.expanded {
    width: 168px;
    margin-right: 24px;

    .assignments-icon {
      margin: 0px 10px;
    }
  }
`;
